/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "solidshop": {
        "nested": {
          "v2": {
            "nested": {
              "common": {
                "nested": {
                  "Locale": {
                    "values": {
                      "EN_US": 1,
                      "ES_US": 2,
                      "EN_CA": 3,
                      "FR_CA": 4,
                      "JA_JP": 5,
                      "EN_AU": 6,
                      "EN_GB": 7,
                      "EN_IE": 8,
                      "FR_FR": 9,
                      "ES_ES": 10,
                      "CA_ES": 11
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.solidshop?.nested?.v2?.nested?.common?.nested?.Locale) {
	$root.addJSON(jsonData);
}

/**
 * SOURCE Locale @ squareup/solidshop/v2/common/locale.proto at 8:1
 */
export const Locale = $root.lookupEnum('squareup.solidshop.v2.common.Locale').values;
